import * as GeneralRepository from "./general-repository";
import * as ADNProvider from "../providers/adn-provider";

export const obtenerADN = async (idProspecto) => {
    const response = await ADNProvider.getAdn(idProspecto)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            adn: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerADN(idProspecto)
            } else {
                return {
                    error: response.auditResponse,
                    adn: null,
                    accessToken: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                adn: null,
                accessToken: null
            }
        }
    }
}